<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-esc="escape" v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Gider Tipi" : "Gider Tipi Düzenle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <form data-vv-scope="form-1" @keyup.enter="submitData">
        <div class="px-6">

          <vs-input id="name" name="Gider Tipi Adı" v-validate="'required|min:2|max:40'" v-model="newExpenseDefinition.name"
            class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Gider Tipi Adı" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Gider Tipi Adı')">{{ errors.first('form-1.Gider Tipi Adı')}}</span>

          <vs-textarea id="description" name="Açıklama" v-validate="'max:100'" v-model="newExpenseDefinition.description"
            class="w-full mt-4 mb-0" icon-pack="feather" icon="icon-calendar" label="Açıklama" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Açıklama')">{{ errors.first('form-1.Açıklama') }}</span>
        </div>
      </form>
      <div class="flex mt-5 px-6 pb-4">
        <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
      </div>
    </VuePerfectScrollbar>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewExpenseDefinition,
    updateExpenseDefinition,
  } from '@/api/ExpenseDefinition';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {

      return {
        newExpenseDefinition: {},

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape(){
        if(this.isSidebarActiveLocal = true) this.isSidebarActiveLocal = false;
      },
      initValues() {
        this.newExpenseDefinition = {};
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker) {
          if (this.newExpenseDefinition.id) {
            updateExpenseDefinition(this.newExpenseDefinition).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("expenseDefinition/updateExpenseDefinition", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Gider Tipi Güncelleme Başarılı ! '
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Gider Tipi Güncelleme Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası ! '
              });
            });
          } else {
            this.newExpenseDefinition.id = 0;
            createNewExpenseDefinition(this.newExpenseDefinition).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("expenseDefinition/addExpenseDefinition", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Gider Tipi Ekleme Başarılı ! '
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: 'Gider Tipi Ekleme Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası ! '
              });
            });
          }
        }
      },
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          Object.assign(this.newExpenseDefinition, this.data); //Şurda.
        }
      },
    },
    mounted: function () {},
    created: async function () {}
  }

</script>

<style lang="scss" scoped>
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>

<style>
.vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
  }
</style>
